import { alpha, styled } from '@mui/material';
import Chip, { chipClasses } from '@mui/material/Chip';

const StyledBadge = styled(Chip)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 1.5,
  ...theme.typography.textSm,
  fontWeight: theme.typography.fontWeightMedium,
  padding: theme.spacing(0.5, 2),
  [`.${chipClasses.label}`]: {
    padding: 0,
  },

  [`& .${chipClasses.icon}`]: {
    marginInlineEnd: theme.spacing(1),
    marginLeft: 0,
  },

  border: '1px solid',
  borderColor: theme.palette.utility.gray200,
  background: theme.palette.createBrandGradients.primary(
    theme.palette.mode === 'dark'
      ? {
          alpha1: alpha(theme.palette.common.black, 0.7),
        }
      : {
          alpha1: alpha(theme.palette.common.white, 0.55),
          alpha2: alpha(theme.palette.common.white, 0.55),
        },
  ),
}));

export default StyledBadge;
